export class TwoFactorResponseModel {
    id:number;
    name: string;
    type: "GOOGLE_AUTHENTICATOR" | "EMAIL";
    sharedSecret: string | null;
    qrCodeString: string | null;
    isFirmMandatoryMfa: boolean;
    emailCode: string | null;
    emailCodeExpiry: string | null;
    isActive: boolean;
    createdBy: number;
    createdAt: string;
    updatedBy: number;
    updatedAt: string;
    userId: number;
}

export class AuthStateModel {
    isToggleStatus: boolean = false;
    isExpandState: boolean = false;
    isAuthEnabled:boolean = false;
    isAuthType: "GOOGLE_AUTHENTICATOR" | "EMAIL" | "NOTYPE" = 'NOTYPE';
    isShowReset: boolean = false;
    isToggleDisable: boolean = false;
    showAuthName: 'Google Authenticator' | 'Email ID' | 'None' = 'None';
}

export class AuthModel {
    message: TwoFactorResponseModel = new TwoFactorResponseModel();
    success: boolean = false;
}

export class GoogleOtpModel {
    message: string;
    success: boolean;
}

export class EmailOtpModel {
  message: string;
  success: boolean;
}

export class EmailModel {
  isSend: boolean  = true;
  isResend: boolean = false;
  text: 'Get Code' | 'Resend Code' = 'Get Code';
  disableResend: boolean = false;
}
